<template>
  <apexchart
    :ref="refChart"
    type="pie"
    width="450"
    :options="options"
    :series="series"
  ></apexchart>
</template>

<script>
  export default {
    props: {
      series: {
        type: Array,
        default: () => [],
      },
      labels: {
        type: Array,
        default: () => [],
      },
      title: {
        type: String,
        default: "",
      },
      refChart:{
        type: String,
        default: "",
      }
    },
    data() {
      return {
        options: {
          chart: {
            width: 380,
            type: "pie",
          },
          title: {
            text: "",
          },
          labels: [],
        },
      }
    },
    watch: {
      labels() {
        const me = this;
        me.updateChart();
      }
    },
    methods: {
      updateChart() {
        const me = this;
        me.$refs[me.refChart].updateOptions(
          {
            labels: [...me.labels],
          }
        );
        me.$refs[me.refChart].updateSeries(me.series);
      }
    },
    created() {
      const me = this;
      me.options.title.text = me.title;
      me.options.labels = [...me.labels];
    }
  }
</script>

<style lang="scss" scoped>

</style>